<template>
  <b-modal
    v-model="internalVisible"
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <template #modal-title>
      <div class="pb-2">
        {{ isEditing ? 'Editar instancia Odoo' : 'Nueva instancia Odoo' }}
      </div>
    </template>

    <b-row>
      <b-col cols="12" md="6">
        <label>Tipo</label>
        <b-form-select v-model="local.type" :options="typeOptions" value-field="value" text-field="text">
            <template #first>
                <b-form-select-option value="">-- Seleccione tipo --</b-form-select-option>
            </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" md="6">
        <label>URL</label>
        <b-form-input v-model="local.url" placeholder="https://mi-odoo.com" />
      </b-col>
      <b-col cols="12" md="6">
        <label>Nombre</label>
        <b-form-input v-model="local.name" />
      </b-col>
      <b-col cols="12" md="6">
        <label>Base de datos</label>
        <b-form-input v-model="local.db_name" />
      </b-col>
      <b-col cols="12" md="6">
        <label>Usuario</label>
        <b-form-input v-model="local.username" />
      </b-col>
      <b-col cols="12" md="6">
        <label>Contraseña</label>
        <b-form-input type="password" v-model="local.password" :placeholder="isEditing ? 'Dejar en blanco para no cambiar' : ''" />
      </b-col>
      <b-col cols="12" class="mt-3">
        <b-alert show variant="danger" v-if="errors.length">
          <ul>
            <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
          </ul>
        </b-alert>
      </b-col>
    </b-row>

    <template #modal-footer>
      <b-button variant="danger" @click.prevent="close">Cancelar</b-button>
      <b-button variant="info" @click.prevent="submit">{{ isEditing ? 'Actualizar' : 'Crear' }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'OdooInstanceFormModal',
  props: {
    visible: { type: Boolean, required: true },
    instanceData: { type: Object, default: () => ({}) },
    isEditing: { type: Boolean, default: false }
  },
  data() {
    return {
        TYPE_PRODUCTION: 'production',
        TYPE_TESTING: 'testing',
        typeOptions: [
            { value: 'production', text: 'Producción' },
            { value: 'testing', text: 'Pruebas' },
        ],
        internalVisible: this.visible,
        local: {
            type: '',
            url: '',
            db_name: '',
            name: '',
            username: '',
            password: ''
        },
        errors: []
    };
  },
  watch: {
    visible(val) {
      this.internalVisible = val;
    },
    internalVisible(val) {
      if (!val) this.$emit('close-modal');
    },
    instanceData: {
      handler(val) {
        this.local = {
          type: val.type || '',
          url: val.url || '',
          name: val.name || '',
          db_name: val.db_name || '',
          username: val.username || '',
          password: ''
        };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    close() {
      this.internalVisible = false;
    },
    async submit() {
      this.errors = [];
      this.setLoading(true);

      try {
        let res;
        if (this.isEditing && this.instanceData.id) {
          // actualizar
          res = await this.$conectar.post(`odoo-client-instance/update/${this.instanceData.id}`, this.local);
        } else {
          // crear
          res = await this.$conectar.post('odoo-client-instance/create', this.local);
        }

        if (res.data.errors) {
          this.errors = Object.values(res.data.errors).flat();
        } else if (res.data.success) {
          this.$emit('saved');
          this.$swal({
            icon: 'success',
            title: this.isEditing ? 'Actualizado' : 'Creado',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000
          });
        } else {
          this.errors = [res.data.message || 'Error desconocido'];
        }
      } catch (e) {
        console.error(e.response || e);
        this.errors = [e.response?.data?.message || 'Fallo en la petición'];
      }

      this.setLoading(false);
    }
  }
};
</script>

<style scoped>
/* pequeños ajustes visuales si hacen falta */
</style>
